export const downloads = [
  {
    bucketName: 'muses-cabinets-files',
    fileName: 'One_Year_Limited_Warranty.pdf',
    region: 'us-east-1',
    titleKey: 'download.oneYearWarranty',
    fileType: 'pdf' as const
  },
  {
    bucketName: 'muses-cabinets-files',
    fileName: 'Muses_Spec_Book_Final_Version.pdf',
    region: 'us-east-1',
    titleKey: 'download.specBook',
    fileType: 'pdf' as const
  },
  {
    bucketName: 'muses-cabinets-files',
    fileName: 'Muses_Farmhouse_Sink_Cutout_Guidelines.pdf',
    region: 'us-east-1',
    titleKey: 'download.sinkGuidelines',
    fileType: 'pdf' as const
  },
  {
    bucketName: 'muses-cabinets-files',
    fileName: '2020 Muses Cabinets Catalog 2023 Edition.zip',
    region: 'us-east-1',
    titleKey: 'download.catalog',
    fileType: 'zip' as const
  }
]
